import { gql } from "@apollo/client";

const CREATE_PRODUCT = gql`
  mutation createProduct($input: CreateProductInput!) {
    createProduct(input: $input) {
      __typename
      ... on Product {
        id
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;
const UPDATE_PRODUCT = gql`
  mutation updateProduct($input: UpdateProductInput!) {
    updateProduct(input: $input) {
      __typename
      ... on Product {
        id
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

const DELETE_PRODUCT = gql`
  mutation deleteProduct($id: Float!) {
    deleteProduct(id: $id) {
      __typename
      ... on Product {
        id
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

const LINK_IMAGE_WITH_PRODUCT = gql`
  mutation linkImageWithProduct($input: LinkImageWithProduct!) {
    linkImageWithProduct(input: $input) {
      __typename
      ... on Product {
        id
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

export {
  CREATE_PRODUCT,
  UPDATE_PRODUCT,
  DELETE_PRODUCT,
  LINK_IMAGE_WITH_PRODUCT,
};
